export async function fetchRoomsByRole({
  commit,
  state,
  role,
  query,
  roomsServiceMethod,
  signalMutationType,
  pendingMutationType,
  successMutationType,
  paginationMutationType,
  errorMutationType,
}) {
  const isPM = role === 'pm'
  const abortKey = isPM ? 'pmAbortController' : 'guestAbortController'
  const paginationKey = isPM ? 'pmPagination' : 'guestPagination'

  if (state[abortKey]) {
    state[abortKey].abort()
  }
  const abortController = new AbortController()
  commit(signalMutationType, abortController)
  commit(pendingMutationType, true)

  try {
    const response = await roomsServiceMethod(
      { ...query, isPM },
      { signal: abortController.signal },
    )

    // Check if the page received matches the expected page
    const requestedPage = query.page
    const currentPage = state[paginationKey].page
    if (requestedPage !== currentPage) {
      return
    }

    commit(successMutationType, response.data?.data || response.data)
    commit(paginationMutationType, response.data?.pagination)
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return
    }
    commit(errorMutationType, error)
    throw error
  } finally {
    // Only disable pending if this controller is still active
    if (state[abortKey] === abortController) {
      commit(pendingMutationType, false)
    }
  }
}
